/**
 * Capability status reported by the management cell for each antenna capability.
 * Used to determine overall antenna health — antennas with non-ENABLED capabilities
 * surface as degraded or in testing unless suppressed by known exceptions.
 */
export enum CapabilityStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  UNKNOWN = 'UNKNOWN',
  INTERNAL_TESTING = 'INTERNAL_TESTING',
}
